import { cellKey } from './coordinates';

export const geometricConflict = (left, right) => {
  const rowDistance = Math.abs(left.row - right.row);
  const columnDistance = Math.abs(left.column - right.column);
  return left.row === right.row
    || left.column === right.column
    || rowDistance === columnDistance;
};

export const conflictingLighthouse = (lighthouses, candidate) => (
  lighthouses.find((lighthouse) => geometricConflict(lighthouse, candidate)) || null
);

export const territoryConflict = (lighthouses, candidate, territories) => {
  const candidateTerritory = territories[candidate.row][candidate.column];
  return lighthouses.find(
    (lighthouse) => territories[lighthouse.row][lighthouse.column] === candidateTerritory,
  ) || null;
};

export const isComplete = ({ size, lighthouses, territories }) => {
  if (lighthouses.length !== size) return false;

  const rows = new Set();
  const columns = new Set();
  const territoryIds = new Set();
  const risingDiagonals = new Set();
  const fallingDiagonals = new Set();

  lighthouses.forEach(({ row, column }) => {
    rows.add(row);
    columns.add(column);
    territoryIds.add(territories[row][column]);
    risingDiagonals.add(row + column);
    fallingDiagonals.add(row - column);
  });

  return rows.size === size
    && columns.size === size
    && territoryIds.size === size
    && risingDiagonals.size === size
    && fallingDiagonals.size === size;
};

export const hasLighthouse = (lighthouses, row, column) => (
  lighthouses.some((lighthouse) => cellKey(lighthouse.row, lighthouse.column) === cellKey(row, column))
);

